
import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { NotificationType } from '@/types/enhancedNotifications';

interface NotificationPreferenceItemProps {
  notificationType: NotificationType;
  title: string;
  description: string;
  inAppEnabled: boolean;
  pushEnabled: boolean;
  onInAppToggle: (enabled: boolean) => void;
  onPushToggle: (enabled: boolean) => void;
  disabled?: boolean;
}

const NotificationPreferenceItem: React.FC<NotificationPreferenceItemProps> = ({
  notificationType,
  title,
  description,
  inAppEnabled,
  pushEnabled,
  onInAppToggle,
  onPushToggle,
  disabled = false
}) => {
  return (
    <div className="flex items-start justify-between py-4 border-b border-gray-700 last:border-b-0">
      <div className="flex-1 pr-4">
        <h4 className="text-sm font-medium text-white mb-1">{title}</h4>
        <p className="text-xs text-gray-400">{description}</p>
      </div>
      
      <div className="flex flex-col gap-3 min-w-[120px]">
        <div className="flex items-center justify-between">
          <Label htmlFor={`${notificationType}-inapp`} className="text-xs text-gray-300">
            In-App
          </Label>
          <Switch
            id={`${notificationType}-inapp`}
            checked={inAppEnabled}
            onCheckedChange={onInAppToggle}
            disabled={disabled}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <Label htmlFor={`${notificationType}-push`} className="text-xs text-gray-300">
            Push
          </Label>
          <Switch
            id={`${notificationType}-push`}
            checked={pushEnabled}
            onCheckedChange={onPushToggle}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationPreferenceItem;
